<template>
  <div
    v-click-outside="clickOutside"
    class="measures-container"
  >
    <div
      class="measures-container__box-button"
      @click="openMeasures()"
    >
      <button
        class="measures-container__btn-open"
        :class="{ 'measures-container--opened': isOpened }"
      >
        Conversão de unidades
        <svg-loader
          class="arrow"
          src="/static/images/arrow-up.svg"
        />
      </button>
    </div>

    <transition name="fade">
      <div
        v-show="openCard"
        class="measures-container__card"
        :class="{ 'measures-container__card--opened': isOpened }"
      >
        <h4>Conversão de unidades</h4>

        <md-input-container
          class="measures-container__card__value-input"
          :class="{
            'md-input-invalid': errorValue,
          }"
        >
          <label>Valor</label>
          <md-input
            id="valuetoConvert"
            v-model="values.valuetoConvert"
            v-validate="'required'"
            v-mask="valuetoConvertMask"
            data-vv-validate-on="none"
            name="valuetoConvert"
            maxlength="20"
            title="Valor"
            placeholder="Valor"
            @focus="handleFocus('value')"
          />
          <input
            v-model="values.valuetoConvert"
            v-mask="valuetoConvertMask"
            type="hidden"
          />
          <span
            v-if="errorValue"
            class="md-error"
          >
            Preencha o valor a ser convertido
          </span>
        </md-input-container>

        <div class="measures-container__card__search">
          <div class="measures-container__card__select">
            <div class="measures-container__card__input-wrapper">
              <input
                v-model="values.measureFrom"
                type="text"
                class="measures-container__card__input-search"
                placeholder="Converter de"
                @input="searchMeaseures"
                @focus="handleFocus('from')"
                @click="handleClick()"
              />
            </div>
            <div
              v-if="showOptionsFrom"
              class="measures-container__card__box-options"
            >
              <div
                v-for="(item, index) in measureFromFiltered"
                :key="`measure-from-${index}-${item}`"
                class="measures-container__card__options"
                @click="handleSelect(item, 'from')"
              >
                <span v-html="item" />
              </div>
            </div>
          </div>
        </div>

        <div
          class="measures-container__card__invert-box"
          @click="invertMeaseures()"
        >
          <svg-loader src="/static/images/icon-invert-values.svg" />
          <h4 class="measures-container__card__invert-title">Inverter</h4>
        </div>

        <div class="measures-container__card__search">
          <div class="measures-container__card__select">
            <div class="measures-container__card__input-wrapper">
              <input
                v-model="values.measureFor"
                type="text"
                class="measures-container__card__input-search"
                placeholder="Para"
                @input="searchMeaseuresFor"
                @click="handleClick()"
                @focus="handleFocus('for')"
              />
            </div>
            <div
              v-if="showOptionsFor"
              class="measures-container__card__box-options"
            >
              <div
                v-for="(item, index) in measeureForFiltered"
                :key="`measure-for-${index}-${item}`"
                class="measures-container__card__options"
                @click="handleSelect(item, 'for')"
              >
                <span v-html="item" />
              </div>
            </div>
          </div>
        </div>

        <div class="measures-container__card__button">
          <button
            class="btn btn-primary btn-calc"
            @click="convertValue()"
          >
            Calcular
          </button>
        </div>

        <div class="calc-card__result">
          <p v-if="!errorMeasures">
            Resultado:
            <span>{{ values.result }}</span>
          </p>

          <p
            v-else
            class="alert-error"
          >
            <img
              src="/static/images/icon-alert-solid.svg"
              alt="icone-alerta"
            />
            <span>Todos os campos são obrigatórios</span>
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import createNumberMask from 'text-mask-addons/dist/createNumberMask'

export default {
  name: 'MeaseuresConverter',
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          // here I check that click was outside the el and his children
          if (!(el === event.target || el.contains(event.target))) {
            // and if it did, call method provided in attribute value
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
  },
  data: () => {
    return {
      isOpened: false,
      showOptionsFrom: false,
      showOptionsFor: false,
      openCard: false,
      values: {
        valuetoConvert: null,
        measureFrom: null,
        measureFor: null,
        result: null,
      },
      errorValue: false,
      errorMeasures: false,
      searchMeaseureValueFrom: '',
      searchMeaseureValueFor: '',
      measeureFiltered: [],
      measeureForFiltered: [],
      measureFromFiltered: [],
      measeures: [
        'µg/dL',
        'µg/L',
        'g/dL',
        'g/L',
        'cg/L',
        'mg/dL',
        'mg/L',
        'mg/mL',
        'ng/L',
        'ng/dL',
        'ng/mL',
        'pg/mL',
        'UI/L',
        'UI/mL',
        'mUI/mL',
        'U/mL',
        'KU/L',
      ],
      valuetoConvertMask: createNumberMask({
        prefix: '',
        includeThousandsSeparator: false,
        thousandsSeparatorSymbol: '.',
        allowNegative: false,
        allowDecimal: true,
        decimalSymbol: '.',
        integerLimit: '9',
        requireDecimal: false,
        decimalLimit: 9,
        allowLeadingZeroes: true,
      }),
    }
  },
  computed: {
    filter() {
      switch (this.values.measureFrom) {
        case 'µg/dL':
          return ['µg/L', 'mg/dL', 'g/dL', 'ng/L']
        case 'µg/L':
          return ['µg/dL', 'mg/dL', 'ng/dL', 'ng/mL']
        case 'g/dL':
          return ['g/L', 'mg/dL', 'µg/dL', 'mg/L']
        case 'g/L':
          return ['mg/dL', 'mg/mL', 'g/dL']
        case 'cg/L':
          return ['mg/dL']
        case 'mg/dL':
          return ['µg/L', 'µg/dL', 'cg/L', 'g/dL', 'g/L', 'mg/L', 'ng/mL']
        case 'mg/L':
          return ['g/dL', 'mg/dL']
        case 'mg/mL':
          return ['g/L']
        case 'ng/L':
          return ['µg/dL']
        case 'ng/mL':
          return ['mg/dL', 'µg/L', 'ng/dL']
        case 'ng/dL':
          return ['µg/L', 'pg/mL', 'ng/mL']
        case 'pg/mL':
          return ['ng/dL']
        case 'UI/L':
          return ['mUI/mL', 'UI/mL']
        case 'UI/mL':
          return ['UI/L']
        case 'mUI/mL':
          return ['UI/L']
        case 'U/mL':
          return ['KU/L']
        case 'KU/L':
          return ['U/mL']
      }
    },
  },
  methods: {
    openMeasures() {
      this.isOpened = !this.isOpened
      this.openCard = !this.openCard
      this.showOptionsFrom = false
      this.showOptionsFor = false
    },
    searchMeaseures(value) {
      this.measureFromFiltered = this.measeures.filter(measeure => {
        return measeure.includes(value.target.value)
      })
      if (this.measureFromFiltered < 1) {
        this.measureFromFiltered.push('Nenhuma unidade encontrada')
      }
    },
    searchMeaseuresFor(value) {
      this.measeureForFiltered = this.measeureFiltered.filter(measeure => {
        return measeure.includes(value.target.value)
      })

      if (this.measeureForFiltered < 1) {
        this.measeureForFiltered.push('Nenhuma unidade encontrada')
      }
    },
    handleFocus(field) {
      if (field == 'for') {
        this.showOptionsFor = true
        this.showOptionsFrom = false
      } else if (field == 'from') {
        this.showOptionsFrom = true
        this.showOptionsFor = false
      } else if (field == 'value') {
        this.showOptionsFrom = false
        this.showOptionsFor = false
      }
    },
    handleClick() {
      if (this.measureFromFiltered.length <= 0) {
        this.measureFromFiltered = this.measeures
      }
    },
    handleSelect(value, field) {
      if (field == 'from') {
        this.values.measureFrom = value
        this.showOptionsFrom = false
        this.values.measureFor = ''
      } else if (field == 'for') {
        this.values.measureFor = value
        this.showOptionsFor = false
      }
      this.measeureForFiltered = this.filter
    },
    clickOutside() {
      this.showOptionsFrom = false
      this.showOptionsFor = false
    },
    convertValue() {
      if (!this.verifyFields()) {
        return false
      }
      this.errorValue = false
      this.errorMeasures = false

      const measureFrom = this.values.measureFrom
      const measureFor = this.values.measureFor
      const valuetoConvert = this.values.valuetoConvert

      let result = ''

      // µg/dL
      if (measureFrom === 'µg/dL') {
        if (measureFor === 'µg/L') {
          result = valuetoConvert * 10
          // µg/L	Multiplicar o valor por 10
        } else if (measureFor === 'mg/dL') {
          result = valuetoConvert / 1000
          // mg/dL	Dividir o valor por 1000
        } else if (measureFor === 'g/dL') {
          result = valuetoConvert / 1000000
          this.values.result =
            result
              .toLocaleString('pt-BR', { minimumFractionDigits: 10 })
              .replace(/(^0+(?=\d))|(,?0+$)/g, '')
              .replace(/[^1-9]{3}$/, '') + measureFor
          return
          //g/dL	Dividir o valor por por 1000000
        } else if (measureFor === 'ng/L') {
          result = valuetoConvert * 10000
          //ng/L	Multiplique o valor por 10000
        }
      }

      // µg/L
      if (measureFrom === 'µg/L') {
        if (measureFor === 'µg/dL') {
          // µg/dL	Dividir o valor por  10
          result = valuetoConvert / 10
        } else if (measureFor === 'mg/dL') {
          // mg/dL Dividir o valor por 10000
          result = valuetoConvert / 10000
        } else if (measureFor === 'ng/dL') {
          // ng/dL Multiplicar o valor por 100
          result = valuetoConvert * 100
        } else if (measureFor === 'ng/mL') {
          //ng/mL	Multiplicar o valor por 1
          result = valuetoConvert * 1
        }
      }

      // g/dL
      if (measureFrom === 'g/dL') {
        if (measureFor === 'g/L') {
          // g/L	Multiplicar o valor por 10
          result = valuetoConvert * 10
        } else if (measureFor === 'mg/dL') {
          //mg/dL	Multiplicar o valor por 1000
          result = valuetoConvert * 1000
        } else if (measureFor === 'µg/dL') {
          //µg/dL	Multiplicar o valor por 1000000
          result = valuetoConvert * 1000000
        } else if (measureFor === 'mg/L') {
          result = valuetoConvert * 10000
        }
      }

      // g/L
      if (measureFrom === 'g/L') {
        if (measureFor === 'mg/dL') {
          //mg/dL	Multiplicar o valor por 100
          result = valuetoConvert * 100
        } else if (measureFor === 'mg/mL') {
          //mg/mL	Multiplicar o valor por 1
          result = valuetoConvert * 1
        } else if (measureFor === 'g/dL') {
          result = valuetoConvert / 10
        }
      }

      // cg/L
      if (measureFrom === 'cg/L') {
        if (measureFor === 'mg/dL') {
          //mg/dL	Multiplicar o valor por 1

          this.values.result = valuetoConvert.replace('.', ',') + measureFor
          return
        }
      }

      // mg/dL
      if (measureFrom === 'mg/dL') {
        if (measureFor === 'µg/L') {
          // µg/L	Multiplicar por 10000
          result = valuetoConvert * 10000
        } else if (measureFor === 'µg/dL') {
          // µg/dL	Multiplicar por 1000
          result = valuetoConvert * 1000
        } else if (measureFor === 'cg/L') {
          // cg/L	Multiplicar o valor por 1
          result = valuetoConvert * 1
        } else if (measureFor === 'g/dL') {
          // g/dL	Dividir o valor por 1000
          result = valuetoConvert / 1000
        } else if (measureFor === 'g/L') {
          // g/L	Dividir o valor por 100
          result = valuetoConvert / 100
        } else if (measureFor === 'mg/L') {
          // mg/L	Multiplicar por 10
          result = valuetoConvert * 10
        } else if (measureFor === 'ng/mL') {
          // ng/mL	Multiplicar por 10000
          result = valuetoConvert * 10000
        }
      }

      // mg/L

      if (measureFrom === 'mg/L') {
        if (measureFor === 'g/dL') {
          //g/dL	Dividir o valor por 10000
          result = valuetoConvert / 10000
        } else if (measureFor === 'mg/dL') {
          //mg/dL	Dividir o valor por 10
          result = valuetoConvert / 10
        }
      }

      // mg/mL
      if (measureFrom === 'mg/mL') {
        if (measureFor === 'g/L') {
          //g/L	Multiplicar o valor por 1
          result = valuetoConvert / 1
        }
      }

      // ng/L
      if (measureFrom === 'ng/L') {
        if (measureFor === 'µg/dL') {
          // µg/dL	Dividir o valor por 10000
          result = valuetoConvert / 10000
        }
      }

      // ng/mL
      if (measureFrom === 'ng/mL') {
        if (measureFor === 'mg/dL') {
          // mg/dL	Dividir o valor por 10000
          result = valuetoConvert / 10000
        } else if (measureFor === 'µg/L') {
          //µg/L	Multiplicar o valor por 1
          result = valuetoConvert * 1
        } else if (measureFor === 'ng/dL') {
          //ng/dL	Multiplicar o valor por 100
          result = valuetoConvert * 100
        }
      }

      // ng/dL
      if (measureFrom === 'ng/dL') {
        if (measureFor === 'µg/L') {
          //µg/L	Dividir o valor por 100
          result = valuetoConvert / 100
        } else if (measureFor === 'pg/mL') {
          //pg/mL	Multiplicar o valor por 10
          result = valuetoConvert * 10
        } else if (measureFor === 'ng/mL') {
          //ng/mL	Dividir o valor por 100
          result = valuetoConvert / 100
        }
      }

      // pg/mL
      if (measureFrom === 'pg/mL') {
        if (measureFor === 'ng/dL') {
          //ng/dL	Dividir o valor por 10
          result = valuetoConvert / 10
        }
      }

      //UI/L
      if (measureFrom === 'UI/L') {
        if (measureFor === 'mUI/mL') {
          // mUI/mL	Multiplicar o valor por 1
          this.values.result = valuetoConvert.replace('.', ',') + measureFor
          return
        } else if (measureFor === 'UI/mL') {
          // UI/mL	Dividir o valor por 1000
          result = valuetoConvert / 1000
        }
      }

      // UI/mL
      if (measureFrom === 'UI/mL') {
        if (measureFor === 'UI/L') {
          // UI/L	Multiplicar o valor por 1000
          result = valuetoConvert * 1000
        }
      }

      //mUI/mL
      if (measureFrom === 'mUI/mL') {
        if (measureFor === 'UI/L') {
          // 	UI/L	Não é necessário converter
          result = valuetoConvert
        }
      }

      //U/mL
      if (measureFrom === 'U/mL') {
        if (measureFor === 'KU/L') {
          //KU/L	Não é necessário converter
          result = valuetoConvert
        }
      }

      //KU/L
      if (measureFrom == 'KU/L') {
        if (measureFor === 'U/mL') {
          //mL	Não é necessário converter
          result = valuetoConvert
        }
      }

      if (
        measureFrom == 'KU/L' ||
        measureFrom == 'U/mL' ||
        measureFrom == 'mUI/mL' ||
        measureFrom == 'cg/L'
      ) {
        this.values.result = result.replace('.', ',') + measureFor
        return
      }

      this.values.result =
        result
          .toLocaleString('pt-BR', { minimumFractionDigits: 5 })
          .replace(/(^0+(?=\d))|(,?0+$)/g, '') + measureFor
    },

    verifyFields() {
      if (!this.values.measureFrom) {
        this.errorMeasures = true
        return false
      }

      if (!this.values.measureFor) {
        this.errorMeasures = true
        return false
      }
      if (!this.values.valuetoConvert) {
        this.errorValue = true
        return false
      }
      if (
        !this.values.measureFrom ||
        !this.values.measureFor ||
        !this.values.valuetoConvert
      ) {
        this.errorValue = !this.values.valuetoConvert ? true : false
        this.errorMeasures =
          !this.values.measureFrom || !this.values.measureFrom ? true : false
        return false
      }
      return true
    },
    invertMeaseures() {
      if (!this.values.measureFrom || !this.values.measureFor) {
        this.errorMeasures = true
        return false
      } else {
        this.errorMeasures = false

        let oldValueFrom = this.values.measureFrom
        let oldValueFor = this.values.measureFor

        this.values.measureFrom = oldValueFor

        this.measeureFiltered = this.filter
        this.measeureForFiltered = this.filter

        this.values.measureFor = this.measeureFiltered.includes(oldValueFrom)
          ? oldValueFrom
          : this.measeureFiltered[0]
      }
    },
  },
}
</script>

<style lang="scss">
.measures-container {
  &__box-button {
    display: flex;
    justify-content: center;
  }
  .arrow {
    transform: rotate(180deg);
    transition: all ease-in-out 0.3s;
  }

  &__btn-open {
    width: 232px;
    height: 32px;
    font-family: 'Exo 2';
    text-transform: uppercase;
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    color: #7f1a54;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    border: 2px solid #7f1a54;
    margin-bottom: 16px;
    .md-icon {
      width: 20px;
      min-width: 20px;
      margin: 0 0 0 10px;
      svg path {
        fill: #7f1a54;
      }
    }
  }
  &--opened {
    .arrow {
      transform: rotate(0);
    }
  }

  &__card {
    background: #ffffff;
    padding: 24px;
    border-radius: 3px;
    margin-top: 16px;
    h4 {
      color: #464646;
      font-size: 13px;
      flex-shrink: 1;
    }
    &__value-input {
      margin: 20px 0;
    }
    &__invert-box {
      cursor: pointer;
      display: flex;
      justify-content: center;
      margin: 15px 0;
      h4 {
        font-weight: 500;
        color: #7f1a54;
      }
      .md-icon {
        width: 16px;
        min-width: 16px;
        margin: 0 10px 0 0;
      }
    }
    &__input-search {
      border: 1px solid #cccccc;
      height: 38px;
      border-radius: 4px;
      padding: 5px 15px 5px 35px;
      background-image: url('/static/images/icon-search-light.svg');
      background-repeat: no-repeat;
      background-position: 10px center;
      width: 100%;
      outline: none;
    }
    &__box-options {
      top: 39px;
      box-shadow: 0px 4px 10px rgba(129, 129, 129, 0.2);
      border-radius: 4px;
      z-index: 1;
      width: 100%;
      max-height: 276px;
      overflow: auto;
      overflow-x: hidden;
    }
    &__options {
      padding: 8px;
      font-weight: 500;
      font-size: 13.33px;
    }
    &__button {
      display: flex;
      justify-content: center;
      .btn {
        width: 102px;
        height: 32px;
        margin-top: 24px;
        border-radius: 4px;
        font-family: 'Exo 2';
      }
    }
  }
}
.calc-card__result {
  color: #818181 !important;
  p {
    margin-top: 0px !important;
  }
}
.slide-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}
.slide-enter-to,
.slide-leave {
  max-height: 100px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>
